/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-outlined': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.974.69a2.358 2.358 0 113.335 3.336l-1.311 1.311a.84.84 0 01-.003.003l-.003.003-6.13 6.13a.5.5 0 01-.353.146H4.88a.5.5 0 01-.5-.5V8.492a.5.5 0 01.147-.353L11.974.69zm1.668 3.59l.96-.96a1.359 1.359 0 00-1.921-1.922l-.96.96 1.92 1.922zm-2.629-1.215l1.921 1.922-5.632 5.633H5.38V8.697l5.633-5.633zM0 5.863A2.252 2.252 0 012.252 3.61H4.88a.5.5 0 010 1H2.252C1.561 4.61 1 5.171 1 5.863v7.884C1 14.44 1.56 15 2.252 15h7.885c.692 0 1.252-.561 1.252-1.253V11.12a.5.5 0 011 0v2.628A2.252 2.252 0 0110.137 16H2.252A2.252 2.252 0 010 13.747V5.863z" _fill="#1F222C"/>'
  }
})
